import React from 'react';
import './index.css';
import { Switch, Route } from 'react-router-dom';
import Login from './Components/Auth/Login';
import ForgotPassword from './Components/Auth/ForgotPassword';
import Register from './Components/Auth/Register';
import Dashboard from './Components/Dashboard/Dashboard';
import EmailVerification from './Components/Auth/EmailVerification';
import UpdatedEmailVerification from './Components/Auth/UpdatedEmailVerification';
import PrivateRoute from './Components/PrivateRoute';
import CurrentDocument from './Components/Documents/CurrentDocument';
import CustomSnackbar from './Common/CustomSnackbar';
import ResetPassword from './Components/Auth/ResetPassword';
import UserHome from './Components/User/UserHome'
import CurrentTemplate from './Components/Templates/CurrentTemplate';
import OutputMapping from './Components/Templates/OutputMapping';
import ExportMapping from './Components/Templates/ExportMapping';
import CurrentDocumentPoSo from './Components/Documents/PO-SO/CurrentDocumentPoSo';

function App() {
  return (
    <div id="app-root">
      <Switch>
        <Route path="/" component={Login} exact />
        <Route path="/login" component={Login} exact />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/register" component={Register} exact />
        <Route path="/user/verifyEmail/:token" component={EmailVerification} />
        <Route path="/user/verifyEmailUpdate/:token" component={UpdatedEmailVerification} />
        <Route path="/user/:type/:token" component={ResetPassword} exact />
        <Route path="/user/:type/:token" component={ResetPassword} exact />
        <PrivateRoute path="/document/finance/:documentId" component={CurrentDocumentPoSo} />
        <PrivateRoute path="/document/:documentId" component={CurrentDocument} />
        <PrivateRoute path="/template/export/:templateId" component={ExportMapping} />
        <PrivateRoute path="/template/mapping/:templateId" component={OutputMapping} />
        <PrivateRoute path="/template/:templateId" component={CurrentTemplate} />
        <PrivateRoute path="/dashboard" component={Dashboard} />
        <PrivateRoute path="/admin" component={UserHome} />
        <PrivateRoute path="/user/settings" component={UserHome} />
        <PrivateRoute path="/statistics" component={UserHome} />
      </Switch>
      <CustomSnackbar></CustomSnackbar>
    </div>
  )
}

export default App;
